import { useVisibleContainer } from "../hooks/useVisibleContainer";

// Route-effect component for "/rewards". Renders nothing -
// RewardsScreen.tsx (mounted unconditionally in AppRoot) owns the actual
// rendering into #rewardsView, which this only shows/hides, same pattern
// as every other route screen. No own data-load effect needed - the
// content screen already loads credits/ledger itself on mount.
export function RewardsRouteScreen() {
  useVisibleContainer("rewardsView");
  return null;
}
